"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const basic_form_input_1 = __importDefault(require("../../../../client/form_components/inputs/basic_form_input"));
const form_select_1 = __importDefault(require("../../../../client/form_components/selects/form_select"));
const form_image_uploader_1 = __importDefault(require("../../../../client/form_components/image_uploaders/form_image_uploader"));
const enums_1 = require("../../../../graphql/challenges/enums");
const radio_group_1 = __importDefault(require("../../../../client/form_components/inputs/radio_group"));
function formatOptions(list) {
    return list.map((item) => {
        if (typeof item === 'string')
            return { value: item, label: item };
        return item;
    });
}
const Input = ({ field, value, onChange, errors }) => {
    const [imageData, setImageData] = (0, react_1.useState)(field.type === 'image' ? { url: value } : {});
    const handleImageUpload = ({ url }) => {
        setImageData({ url });
        onChange(url);
    };
    if (field.type === 'select' || field.type === 'multi') {
        const isMulti = field.type === 'multi';
        const valueData = { label: value, value };
        const handleOptionChange = (options) => {
            onChange(isMulti ? JSON.stringify(options?.map(({ value }) => value)) : options?.value);
        };
        return (react_1.default.createElement(form_select_1.default, { errors: errors, label: field.label, onSelectedChange: handleOptionChange, options: formatOptions(field.options), placeholder: field.placeholder, type: (0, enums_1.getTypeForFormSelect)(field.type), value: valueData }));
    }
    if (field.type === 'radio') {
        return (react_1.default.createElement(radio_group_1.default, { buttons: formatOptions(field.options), errors: errors, label: field.label, onChange: (e) => onChange(e.target.value), value: value }));
    }
    if (field.type === 'image') {
        return (react_1.default.createElement(form_image_uploader_1.default, { allowRemoteURL: true, errors: errors, imageData: { url: imageData?.url }, label: field.label, propagateUpload: handleImageUpload }));
    }
    return (react_1.default.createElement(basic_form_input_1.default, { element: field.type, errors: errors, label: field.label, onChange: (e) => onChange(e.target.value), type: field.type, value: value }));
};
exports.default = Input;
